import s from "../clinic.module.css";
import aa from "../AdminPortal/adminApp.module.css";
import { Field, Input } from "../../ui";
import { addMinutesToTime, timeToMinutes } from "./calendarUtils";

const DEFAULT_DURATIONS = [45, 60, 90, 120];

function durationLabel(minutes) {
  if (minutes % 60 === 0) return `${minutes / 60} ч`;
  if (minutes > 60 && minutes % 60 !== 0) {
    return `${Math.floor(minutes / 60)} ч ${minutes % 60} м`;
  }
  return `${minutes} м`;
}

export default function SessionDateTimeFields({
  date,
  startTime,
  endTime,
  onChange,
  durationPresets = DEFAULT_DURATIONS,
  className = "",
  sheet = false,
}) {
  const patch = (next) => onChange({ date, startTime, endTime, ...next });

  const onDate = (e) => patch({ date: e.target.value });

  const onStart = (e) => {
    const nextStart = e.target.value;
    let nextEnd = endTime;
    if (timeToMinutes(nextEnd) <= timeToMinutes(nextStart)) {
      nextEnd = addMinutesToTime(nextStart, 60);
    }
    patch({ startTime: nextStart, endTime: nextEnd });
  };

  const onEnd = (e) => patch({ endTime: e.target.value });

  const applyDuration = (minutes) => {
    patch({ endTime: addMinutesToTime(startTime, minutes) });
  };

  const activeDuration = durationPresets.find(
    (m) => addMinutesToTime(startTime, m) === endTime,
  );

  const wrapClass = [
    s.calSessionSchedule,
    sheet ? aa.calSlotScheduleFields : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  const durationChip = (minutes) =>
    sheet
      ? `${aa.calSlotDurationChip} ${
          activeDuration === minutes ? aa.calSlotDurationChipOn : ""
        }`
      : `${s.calDurationChip} ${
          activeDuration === minutes ? s.calDurationChipActive : ""
        }`;

  const durationRowClass = sheet ? aa.calSlotDurationRow : s.calDurationRow;
  const durationLabelClass = sheet ? aa.calSlotDurationLabel : s.calDurationLabel;
  const editRowClass = sheet ? aa.calSlotEditRow : s.calEditRow;

  return (
    <div className={wrapClass}>
      <Field label="Дата">
        <Input type="date" value={date} onChange={onDate} required />
      </Field>
      <div className={editRowClass}>
        <Field label="Начало">
          <Input
            type="time"
            value={startTime}
            onChange={onStart}
            step={300}
            required
          />
        </Field>
        <Field label="Окончание">
          <Input
            type="time"
            value={endTime}
            onChange={onEnd}
            step={300}
            min={startTime || undefined}
            required
          />
        </Field>
      </div>
      {durationPresets.length > 0 ? (
        <div className={durationRowClass}>
          <span className={durationLabelClass}>Длительность</span>
          {durationPresets.map((minutes) => (
            <button
              key={minutes}
              type="button"
              className={durationChip(minutes)}
              onClick={() => applyDuration(minutes)}
            >
              {durationLabel(minutes)}
            </button>
          ))}
        </div>
      ) : null}
    </div>
  );
}
